import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles} from "@material-ui/core/styles";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Button from '@material-ui/core/Button';
import { history } from '../_redux/_store/history'

import {
  setBreadcrumb,
  setBreadcrumbSearch
} from '../_redux/_actions/breadcrumbAction'

const useStyles = makeStyles((theme) => ({
  breadcrumb: {
    color: "#262523",
    textTransform: "capitalize",
    zIndex: 1,
    position: "relative",
    background: "#f6f6f6",
    position: "fixed",
    width: "100%",
    top: "64px",
  },
  breadcrumbActive: {
    fontWeight: "bold"
  }
}));

export default function BreadCrumb() {
  const classes = useStyles();
  const dispatch = useDispatch()
  const [breadcrumbList, setBreadcrumbList] = useState("");
  const breadcrumbResponse = useSelector(
    (state) => state.breadcrumb
  )

  useEffect (() => {
    const newArr = breadcrumbResponse.breadcrumb.filter((a) => a);
    let availList = []
    let link =""
    newArr.forEach((newarr)=>{
      if(newarr !== "anomalyexpertui"){
        link=link +"/"+newarr
        availList.push({
         name: newarr.replace(/#|_/g,' '),
         link: link
        })
      }
    })
    setBreadcrumbList(availList)
    },[breadcrumbResponse])

    const onBreadcrumbClick = () =>{
      var pathArray = window.location.pathname.split("/") ;
      if(window.location.search){
        pathArray[pathArray.length-1]= pathArray[pathArray.length-1]
      }
      dispatch(setBreadcrumb(pathArray))
      if(window.location.search){
      dispatch(setBreadcrumbSearch(window.location.search.split('&')))
      }
    }

    const handleBreadCrumbClick = (key,breadcrumbs) =>{
      let routePath;
      if(key !== breadcrumbList.length - 1){
        switch(breadcrumbs.name){
          case 'select scope':
          case 'select scoped anomaly rule':
              routePath = `${breadcrumbs.link}${breadcrumbResponse.breadcrumbSearch[0]}&${breadcrumbResponse.breadcrumbSearch[1]}&${breadcrumbResponse.breadcrumbSearch[2]}`;
              break;
          case 'select finding rule':
          case 'select anomaly rule':
              routePath = `${breadcrumbs.link}${breadcrumbResponse.breadcrumbSearch[0]}&${breadcrumbResponse.breadcrumbSearch[1]}`;
              break;
          default :
             routePath = `${breadcrumbs.link}${breadcrumbResponse.breadcrumbSearch[0]}&${breadcrumbResponse.breadcrumbSearch[1]}`;
             break;
        }
      }
      else{
        routePath = ''
      }
      history.push(routePath)   
      onBreadcrumbClick()
    }

    return (
      <Breadcrumbs aria-label="breadcrumb" className ={classes.breadcrumb} separator="›">
      {breadcrumbList? breadcrumbList.map((breadcrumbs, key) => (
          <Button key={key} onClick={() => {handleBreadCrumbClick(key,breadcrumbs); onBreadcrumbClick()}}  className={key === breadcrumbList.length - 1 ?classes.breadcrumbActive:null}>
            {breadcrumbs.name}
          </Button>
        )):null}
      </Breadcrumbs>
    );
}
